<h2 mat-dialog-title>
  <span>{{ isEditMode ? "Edit" : "Add" }} Branch/Location</span>
  <div class="subtitle">
    {{
      isEditMode
        ? "Edit the branch or outlet location for this merchant."
        : "Add a new branch or outlet location for this merchant."
    }}
  </div>
</h2>

<mat-dialog-content [formGroup]="form">
  <div class="pv-xs" fxLayout="column">
    <mat-checkbox formControlName="isHQ" fxLayoutAlign="end"
      >Set as HQ</mat-checkbox
    >

    <mat-form-field appearance="outline">
      <mat-label>Branch Name</mat-label>
      <input
        formControlName="branchName"
        matInput
        placeholder="e.g., IOI City Mall, One Utama, Mid Valley"
      />
      <mat-error *ngIf="form.get('branchName').hasError('required')">
        Branch Name is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Branch Address</mat-label>
      <textarea
        formControlName="branchAddress"
        matInput
        placeholder="Enter complete branch address"
        rows="5"
      ></textarea>
      <mat-error *ngIf="form.get('branchAddress').hasError('required')">
        Branch Address is required
      </mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutGap="12px">
      <mat-form-field appearance="outline" fxFlex="50%">
        <mat-label>Postcode</mat-label>
        <input
          formControlName="postcode"
          mask="00000"
          matInput
          placeholder="e.g., 52000"
        />
        <mat-error *ngIf="form.get('postcode').hasError('required')">
          Postcode is required
        </mat-error>
        <mat-error
          *ngIf="
            form.get('postcode').hasError('minlength') ||
            form.get('postcode').hasError('maxlength')
          "
        >
          Postcode must be 5 digits
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="50%">
        <mat-label>State</mat-label>
        <mat-select formControlName="state" placeholder="Select state">
          <mat-option *ngFor="let state of states" [value]="state.value">
            {{ state.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('state').hasError('required')">
          State is required
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Country</mat-label>
      <mat-select formControlName="country">
        <mat-option *ngFor="let country of countries" [value]="country.value">
          {{ country.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('country').hasError('required')">
        Country is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let status of statuses" [value]="status.value">
          {{ status.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('status').hasError('required')">
        Status is required
      </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    (click)="onNext()"
    [disabled]="form.invalid || (isEditMode && !isFormChanged)"
    color="primary"
    mat-raised-button
  >
    {{ isEditMode ? "Update" : "Add" }} Branch
  </button>
</mat-dialog-actions>
